import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { WhatIsEbook } from './components/WhatIsEbook';
import { Problem } from './components/Problem';
import { WhatIsBook } from './components/WhatIsBook';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { BookDescription } from './components/BookDescription';
import { CTA } from './components/CTA';
import { BonusWorkbook } from './components/BonusWorkbook';
import { InteractiveAccess } from './components/InteractiveAccess';
import { WhatYouGet } from './components/WhatYouGet';
import { TableOfContents } from './components/TableOfContents';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '401851746104415';
// Social / SEO preview values. NOTE: Facebook, WhatsApp and other social
// crawlers read the STATIC HTML <head> generated at publish time — they do
// NOT execute this client-side JS. For the shared-link preview to be correct
// you must ALSO set the SEO title, description and image in the Magic Patterns
// PUBLISH panel. The injection below keeps the browser tab title and in-app
// meta consistent, and helps tools that do run JS.
const SEO = {
  title: '¿Estás listo para jugar? — Ebook digital + bono incluido',
  description: 'Una experiencia digital en español para reflexionar, cuestionar creencias, observar patrones y mirar tu vida desde una nueva perspectiva. Incluye ebook principal, bono de reflexión de 31 páginas y acceso interactivo protegido.',
  ogTitle: '¿Estás listo para jugar? — Ebook digital + bono incluido',
  ogDescription: 'Ebook digital + cuaderno de reflexión de 31 páginas + acceso interactivo protegido. Una lectura profunda para observar patrones, creencias y formas de vivir en automático con más conciencia.',
  twitterTitle: '¿Estás listo para jugar? — Ebook digital + bono incluido',
  twitterDescription: 'Ebook digital en español con bono de reflexión de 31 páginas y acceso interactivo protegido.',
  image: 'https://cdn.magicpatterns.com/uploads/2ocXgWM98g184BsyCpkgMT/paquete-ebook-bono-acceso.webp'
};
export function App() {
  // SEO / Open Graph / Twitter metadata — upsert into <head> at runtime so the
  // browser tab title and JS-aware tools reflect the product, replacing any
  // stale placeholder title. (Static social crawlers still need the PUBLISH
  // panel values — see the SEO comment above.)
  useEffect(() => {
    try {
      document.title = SEO.title;
      const upsertMeta = (key: 'name' | 'property', value: string, content: string) => {
        let el = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`);
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute(key, value);
          document.head.appendChild(el);
        }
        el.setAttribute('content', content);
      };
      upsertMeta('name', 'description', SEO.description);
      upsertMeta('property', 'og:type', 'website');
      upsertMeta('property', 'og:title', SEO.ogTitle);
      upsertMeta('property', 'og:description', SEO.ogDescription);
      upsertMeta('property', 'og:image', SEO.image);
      upsertMeta('property', 'og:image:width', '1200');
      upsertMeta('property', 'og:image:height', '630');
      upsertMeta('name', 'twitter:card', 'summary_large_image');
      upsertMeta('name', 'twitter:title', SEO.twitterTitle);
      upsertMeta('name', 'twitter:description', SEO.twitterDescription);
      upsertMeta('name', 'twitter:image', SEO.image);
    } catch (err) {
      // Metadata failure must never crash the app render.
      console.warn('[seo] meta injection failed:', err);
    }
  }, []);
  // Meta Pixel install — inlined here (no separate lib file) because Magic
  // Patterns ignores index.html / src/index.tsx, so any pixel code outside
  // the React component tree never reaches production.
  useEffect(() => {
    try {
      const w = window as unknown as {
        fbq?: ((...args: unknown[]) => void) & {
          callMethod?: (...args: unknown[]) => void;
          queue?: unknown[];
          push?: unknown;
          loaded?: boolean;
          version?: string;
        };
        _fbq?: unknown;
      };
      // If something else (or a previous mount) already loaded fbq, just
      // fire PageView and bail — the snippet is idempotent.
      if (typeof w.fbq === 'function') {
        w.fbq('track', 'PageView');
        return;
      }
      // Standard Meta Pixel base snippet, written out longhand.
      const fbq = function (this: unknown) {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args as unknown as unknown[]);
        } else {
          ;
          (fbq.queue as unknown[]).push(args);
        }
      } as ((...args: unknown[]) => void) & {
        callMethod?: (...args: unknown[]) => void;
        queue: unknown[];
        push: unknown;
        loaded: boolean;
        version: string;
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Append to head/body/documentElement — at least one is always
      // present, including in Magic Patterns' sandboxed editor preview
      // (where document.getElementsByTagName('script')[0] can be undefined).
      const host = document.head || document.body || document.documentElement;
      host?.appendChild(script);
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (err) {
      // Pixel failure must never crash the app render.
      console.warn('[fbpixel] init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-matrix-black text-matrix-white font-inter selection:bg-matrix-green selection:text-matrix-black" data-id="element-0">
      <Hero data-id="element-1" />
      <WhatIsEbook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhatIsBook data-id="element-4" />
      <Revelation data-id="element-5" />
      <Benefits data-id="element-6" />
      <BookDescription data-id="element-7" />
      <BonusWorkbook data-id="element-8" />
      <InteractiveAccess data-id="element-9" />
      <WhatYouGet data-id="element-10" />
      <TableOfContents data-id="element-11" />
      <CTA data-id="element-12" />
      <PricingCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}